export default "__VITE_ASSET__BRbICtgg__"